import { z } from "zod";

export const PreSurveySchema = z
  .object({
    id: z.number(),
    geometry: z.any(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
    UKHab_L2: z.string().optional().nullable(),
    Notes: z.string().optional().nullable(),
    Essential: z.string().array().optional(),
    Additionals: z.string().array().optional(),
    area: z.number().optional(),
    length: z.number().optional(),
    ukHabPName: z.string().optional(),
    ukHabPCode: z.string().optional(),
    ukHabCCode: z.string().optional(),
    ukHabS1Cod: z.string().optional(),
    ukHabS1Nam: z.string().optional(),
    ukHabS2Cod: z.string().optional(),
    ukHabS2Nam: z.string().optional(),
    ukHabS3Cod: z.string().optional(),
    ukHabS3Nam: z.string().optional(),
    ukHabS4Cod: z.string().optional(),
    ukHabS4Nam: z.string().optional(),
    ukHabS5Cod: z.string().optional(),
    ukHabS5Nam: z.string().optional(),
    ukHabS6Cod: z.string().optional(),
    ukHabS6Nam: z.string().optional()
  })
  .strict();
export type PreSurvey = z.infer<typeof PreSurveySchema>;

export type CreateGeoType = 'Polygon' | 'LineString' | 'Point';
